import { inPercentage, adjust } from "./util"

/** Module de calcul du taux solide */

/**
 * 
 * @param {*} dFiltrate densité de filtrat
 * @param {*} dPorridge densité de bouillie
 */
export const solidRate = (dFiltrate, dPorridge, gypsumConstant = 2.32) => {
    return adjust(inPercentage((1 - (dFiltrate / dPorridge)) / (1 - (dFiltrate / gypsumConstant))), 1) // Return %sol => float
}